import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ChevronRight } from 'lucide-react';
import api from '@/lib/api';
import Loader from '@/components/common/Loader';

// Generic browse hub for room | style | material | festival | collection
const CONFIG = {
  room: { title: 'Shop by Room', eyebrow: 'Every Space, Perfected', linkBase: '/rooms', type: 'room', visual: true },
  style: { title: 'Shop by Style', eyebrow: 'Find Your Aesthetic', linkBase: '/style', type: 'style', visual: false },
  material: { title: 'Shop by Material', eyebrow: 'Crafted to Last', linkBase: '/material', type: 'material', visual: false },
  festival: { title: 'Shop by Festival', eyebrow: 'Celebrate in Style', linkBase: '/festival', type: 'festival', visual: true },
  collection: { title: 'Our Collections', eyebrow: 'Curated Edits', linkBase: '/collection', type: 'collection', visual: true },
};

export default function BrowseHub({ kind }) {
  const cfg = CONFIG[kind];
  const [items, setItems] = useState(null);
  useEffect(() => { api.get('/categories', { params: { type: cfg.type } }).then((r) => setItems(r.data)).catch(() => setItems([])); }, [kind]);
  if (!items) return <Loader />;

  return (
    <div>
      <div className="border-b border-border bg-white">
        <div className="container-gaze py-8">
          <nav className="mb-2 flex items-center gap-1 text-xs text-muted-foreground"><Link to="/">Home</Link><ChevronRight size={12} /><span className="text-foreground">{cfg.title}</span></nav>
          <p className="eyebrow mb-2">{cfg.eyebrow}</p>
          <h1 className="text-3xl font-semibold sm:text-4xl">{cfg.title}</h1>
        </div>
      </div>
      <div className="container-gaze py-8">
        {cfg.visual ? (
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
            {items.map((it) => (
              <Link key={it.id} to={`${cfg.linkBase}/${it.slug}`} data-testid="browse-card" className="group relative block overflow-hidden rounded-2xl">
                <div className="aspect-[3/4] overflow-hidden bg-[hsl(var(--gaze-ivory))]"><img src={it.image} alt={it.name} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" /></div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
                <div className="absolute bottom-4 left-4 right-4"><h3 className="font-display text-xl text-white">{it.name}</h3><span className="text-xs text-white/80">{it.count} items</span></div>
              </Link>
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
            {items.map((it) => (
              <Link key={it.id} to={`${cfg.linkBase}/${it.slug}`} data-testid="browse-card" className="flex items-center justify-between rounded-xl border border-border bg-white p-5 transition hover:hairline-gold hover:shadow-md">
                <div><span className="font-display text-lg">{it.name}</span><p className="text-xs text-muted-foreground">{it.count} items</p></div>
                <ArrowRight size={16} className="text-muted-foreground" />
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
